module.exports = "/_next/static/images/eth-0ac404baa9e11920e7b1fe2706874513.svg";